import { localDb } from '@core/database/local-database';
import { DartCounterPlayingMatch } from '@dc-core/dc-gamelogic/in-game/match/match.in-game.classes';
import { LocalGameUnfinishedStorageKeys } from 'src/app/modules/local-games/types/local-game-settings.definitions';

export async function migrateUnfinishedLocalMatches(): Promise<void> {
    const legacyKey = LocalGameUnfinishedStorageKeys.Match;

    const raw = localStorage.getItem(legacyKey);
    if (!raw) {
        // Nothing to migrate
        return;
    }

    let storedUnfinishedMatches: DartCounterPlayingMatch[];
    try {
        storedUnfinishedMatches = JSON.parse(raw);
    } catch {
        console.error('[Dexie migrate] Failed to parse unfinished games from localStorage');
        // Stop here and don't clear the old ones
        return;
    }

    if (!Array.isArray(storedUnfinishedMatches) || storedUnfinishedMatches.length === 0) {
        localStorage.removeItem(legacyKey);
        return;
    }

    // Start migration to IndexedDB
    await localDb.transaction('rw', localDb.unfinishedLocalMatches, async () => {
        for (const match of storedUnfinishedMatches) {
            if (!match || !match.started_at) continue;

            const id = String(match.started_at); // We used started_at as the identifier
            await localDb.unfinishedLocalMatches.put({
                id,
                started_at: match.started_at,
                updated_at: Date.now(),
                match,
            });
        }
    });

    // Remove old items from localStorage
    localStorage.removeItem(legacyKey);
}
